import { SpotType } from '../models/cart.ts'

import { spotTypesWithoutSetupSeats } from './constants.ts'

export const isSpotWithSeats = (spotType: SpotType) => {
  return !!spotType && !spotTypesWithoutSetupSeats.includes(spotType)
}
